import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton, SecondaryIconButton } from '../../theme/index';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import SuccessModal from '../SuccessModal';
import DangerModal from '../DangerModal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from 'axios';
import { saveUserIdAction } from '../../redux/reducers/Delete';
import {collection, getDocs, addDoc, query} from 'firebase/firestore';
import db from "../../config/firebase";

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)


function createData(id, name, lastname, email, role, status) {
    return { id, name, lastname, email, role, status};
  }

const rows = [
    createData('1', 'Juan Manuel', 'Ruiz Burgos', 'juanmanuelrb@gmail.com', 'admin', true),
    createData('2', 'José Luis', 'García López', 'joseluis22@hotmail.com', 'admin', true),
];


const Users = () => {

    const [ clients, setClients ] = useState([]);
    const [ search, setSearch ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const searchData = useSelector( state => state.Search.data );
    const newUserData = useSelector( state => state.Create.user );
    const userToDelete = useSelector( state => state.Delete.userId );
    const userStatusDelete = useSelector( state => state.Delete.userStatus );
    const userToEdit = useSelector( state => state.Edit.userEdited );
    const [ userData, setUserData ] = useState('');

    useEffect( () => {
        if (newUserData.role){
            let currentUsers = [newUserData, ...clients];
            setClients(currentUsers);
        }
    },[newUserData] )

    useEffect( () => {
        if(userStatusDelete == 'SUCCESS'){
            const currentClients = clients.filter( item => item.id !== userToDelete);
            console.log(currentClients);
            setClients(currentClients);
        }
    },[userStatusDelete] )

    useEffect( () => {
        if(userToEdit !== {}){
            let listEdited = clients.map( item => {
                return (item.id == userToEdit.id) ? {...userToEdit} : item ;
            } );

            setClients(listEdited);
        }
    },[userToEdit] )

    useEffect( () => {
        
        const petition = async () => {
            const q = query(collection(db, "user"));
            const querySnapshot = await getDocs(q);
            let userArray = [];
            querySnapshot.forEach((doc) => {
                userArray.push({id: doc.id, ...doc.data()});
            });
            addData(userArray);
        }

        const addData = async (clientList) => {
            let data = [];
            await clientList.forEach((doc) => {
                data.push(doc);
            });
            setClients(data.reverse());
        }

        petition();
        
    },[] );

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        const textToSearch = searchData.toLowerCase();
        const mappingArray = rows.filter( (item, index) => {
            return ( index >= initResult && index < endResult ) ? item : null;
        } );

        if(searchData !== ''){
            const filteredElements = clients.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) || 
                                                  item.lastname.toLowerCase().includes(textToSearch) ||
                                                  item.email.toLowerCase().includes(textToSearch) ||
                                                  item.role.toLowerCase().includes(textToSearch) );
            setSearch(filteredElements);
        }else{
            // const filteredElements = mappingArray.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) || 
            //                                       item.lastname.toLowerCase().includes(textToSearch) ||
            //                                       item.email.toLowerCase().includes(textToSearch) ||
            //                                       item.role.toLowerCase().includes(textToSearch) );
            // setClients(filteredElements);
        }

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowModal(modalStatus);
        if (!modalStatus) setModalForm('')
    }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    const editClient = (data) => {
        setModalForm('editUser');
        setUserData(data);
        setDeleteModal('');
        dispatch(modalAction());
    }

    const deleteClient = (id) => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('user');
        dispatch(saveUserIdAction(id));
    }

  return (
    <>
        {
            (showModal && modalForm !== '' ) &&
            <SuccessModal view={modalForm} user={userData} />
        }
        {
            (showDeleteModal && deleteModal !== '' ) &&
            <DangerModal view={deleteModal} />
        }
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Apellido</TableCell>
                    <TableCell>E-mail</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {(searchData !== '') && search.map((row, index) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.lastname}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.role}</TableCell>
                    <TableCell>{
                        (row.status === "true") ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient(row.id) }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}


                {(searchData == '') && clients.map((row, index) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.lastname}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.role}</TableCell>
                    <TableCell>{
                        (row.status === "true") ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient(row.id) }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default Users